import {graphql, useStaticQuery} from 'gatsby';


export default function useProductos() {
    const datos = useStaticQuery(graphql`
        query {
            allStrapiProductos {
                nodes {
                    nombre
                    id
                    subtitulo
                    imagen {
                        childImageSharp{
                            fluid(maxWidth:600){
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                    categoria {
                        Nombre
                        
                        }
                    }
                }
            }
    `);
    


    return datos.allStrapiProductos.nodes.map(producto => ({
        nombre: producto.nombre,
        id: producto.id,
        subtitulo: producto.subtitulo,
        imagen: producto.imagen,
        categoria: producto.categoria,
    }))
}
